import React from 'react';
import { Button } from '../ui/Button';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-brand-cream/90 backdrop-blur-md border-b border-brand-sand/50" data-id="element-28">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-29">
        <a href="#" className="flex-shrink-0" data-id="element-30">
          <img src="https://cdn.magicpatterns.com/uploads/6zVxVDcuBq3mmxqMcw9Y4b/helen_gerberg_(1900_x_800_px).png" alt="Helen Gerberg - Revela tu verdadero ser" className="h-12 md:h-16 w-auto object-contain" data-id="element-31" />
        </a>
        <nav className="hidden md:flex items-center gap-8" data-id="element-32">
          <a href="#masterclass" className="text-sm font-sans text-brand-ink/80 hover:text-brand-eucalyptus transition-colors" data-id="element-33">
            Masterclass
          </a>
          <a href="#sobre-mi" className="text-sm font-sans text-brand-ink/80 hover:text-brand-eucalyptus transition-colors" data-id="element-34">
            Sobre mí
          </a>
        </nav>
        <Button href="https://api.leadconnectorhq.com/widget/booking/kiMwaUwzHpX0z6UxKbPj" variant="primary" className="hidden sm:inline-flex !px-6 !py-2.5 !text-[13px]" data-id="element-35">
          Agendar llamada
        </Button>
      </div>
    </header>;
}